import css from 'astroturf';

export default require('./RequestTableCss.module.scss');
